(function () {
  'use strict';

  if (window.__productGalleryStickyLoaded__) return;
  window.__productGalleryStickyLoaded__ = true;

  function initStickyTop() {
    document.querySelectorAll('product-sticky').forEach(function (stickyEl) {
      var formWrapper = stickyEl.querySelector('[data-form-wrapper]');
      var stickyWrap = stickyEl.querySelector('.product__gallery-sticky-wrap');
      if (!formWrapper || !stickyWrap || stickyWrap.__stickyObserver__) return;

      var observer = new MutationObserver(function () {
        var val = formWrapper.style.getPropertyValue('--sticky-top');
        if (val) stickyWrap.style.setProperty('--sticky-top', val);
      });
      observer.observe(formWrapper, { attributes: true, attributeFilter: ['style'] });
      stickyWrap.__stickyObserver__ = observer;
    });
  }

  function initHeightMirror() {
    // Mirror --height from product-images up to .product__page so
    // .product__content can use it for max-height when scrollable mode is on
    document.querySelectorAll('product-images').forEach(function (productImages) {
      if (productImages.__heightObserver__) return;
      var productPage = productImages.closest('.product__page');
      if (!productPage) return;

      var syncHeight = function () {
        var val = productImages.style.getPropertyValue('--height');
        if (!val || val === '0px') {
          // setHeight() not yet run, ran too early, or single-image product — measure directly
          var media = productImages.querySelector('[data-image-id]');
          if (media && media.offsetHeight) val = media.offsetHeight + 'px';
        }
        if (val && val !== '0px') productPage.style.setProperty('--gallery-height', val);
      };

      var heightObserver = new MutationObserver(syncHeight);
      heightObserver.observe(productImages, { attributes: true, attributeFilter: ['style'] });
      productImages.__heightObserver__ = heightObserver;
      productImages.__syncHeight__ = syncHeight;

      // Initial sync — also re-run after images have loaded/painted
      syncHeight();
      requestAnimationFrame(syncHeight);
      document.addEventListener('theme:resize:width', syncHeight);
    });
  }

  function teardown(sectionEl) {
    sectionEl.querySelectorAll('product-images').forEach(function (productImages) {
      if (productImages.__syncHeight__) {
        document.removeEventListener('theme:resize:width', productImages.__syncHeight__);
        delete productImages.__syncHeight__;
      }
      if (productImages.__heightObserver__) {
        productImages.__heightObserver__.disconnect();
        delete productImages.__heightObserver__;
      }
    });
  }

  function init() {
    initStickyTop();
    initHeightMirror();
  }

  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:section:unload', function (e) {
    teardown(e.target);
  });
})();
